import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store';
import vuetify from './plugins/vuetify'
import { loadLocaleMessages, createI18n } from "./i18n";  
import VueApexCharts from "vue-apexcharts";
import axios from 'axios';
import VueWysiwyg from '@mycure/vue-wysiwyg';
import FloatingVue from 'floating-vue'
import constants from './assets/js/constants';
import tableResizeable from "./directives/table-resizeable.js";

import VueSignature from "vue-signature-pad";
import VueCropper from 'vue-cropper';


Vue.directive("table-resizeable", tableResizeable); 
Vue.use(VueCropper);
Vue.use(VueSignature);


const urlSearchParams = new URLSearchParams(window.location.search);
const obfuscatedDocId = urlSearchParams.get('docId');
const obfuscatedTrasferId = urlSearchParams.get('transferId');
try {
    if (obfuscatedDocId !== null && obfuscatedDocId !== undefined) {
        const docId = atob(obfuscatedDocId);
        sessionStorage.setItem('docId', docId);
    }
    if (obfuscatedTrasferId != null && obfuscatedTrasferId != undefined) {
        const transferId = atob(obfuscatedTrasferId);
        sessionStorage.setItem('transferId', transferId);
    }
} catch (error) {
    console.error('Error decoding obfuscatedDocId:', error);
}
axios.defaults.headers = {
    Accept: 'application/json; charset=utf-8',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '-1'
}

axios.interceptors.request.use(
    (config) => {
        config.headers['Accept-Language'] = localStorage.getItem('lang')
        let token = localStorage.getItem('user')
        if (token)
            config.headers['Authorization'] = `Bearer ${token}`;

        config.headers['ApplicationName'] = 'CTS Web'

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)
//  commonFunctions.initXHRRequests(axios, true);
axios.interceptors.response.use(undefined, function (error) {
    if (error) {
        if (error && error.response && error.response.status == 401) {
            // document.getElementById('login').click();
            localStorage.removeItem("user");
            sessionStorage.removeItem("user");
            // Only redirect if not already on login page
            if (router.currentRoute.name !== 'login' && router.currentRoute.path !== '/ExDocSign') {
                router.push({ name: "login" }).catch(err => {
                    // Ignore navigation duplicate errors
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        }
        return Promise.reject(error);
    }
});

Vue.config.productionTip = false

Vue.use(VueApexCharts)
Vue.use(VueWysiwyg)
Vue.use(FloatingVue)

document.title = constants.applicationTitle
Vue.config.productionTip = false;
// const app = new Vue({
//     render: h => h(App),
//     router,
//     store,
//     vuetify,
//     i18n,
//     mounted() {
//         // console.log("Vue is successfully mounted!");
//     }
// }).$mount("#app");
loadLocaleMessages().then((messages) => {
  const i18n = createI18n(messages);

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
    mounted() {
      console.log("Vue is successfully mounted!");
    },
  }).$mount("#app");
});